"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var React = __importStar(require("react"));

var facebookpage_1 = __importDefault(require("./subtypes/facebookpage"));

var C = function C(_a) {
  var data = _a.data,
      renderEmpty = _a.renderEmpty;

  switch (data.subtype) {
    case 'facebookpage':
      return React.createElement(facebookpage_1["default"], {
        config: data.config || {}
      });

    default:
      return renderEmpty ? renderEmpty(data.type) : null;
  }
};

exports["default"] = C;